export default "__VITE_ASSET__3fd88d98__"